import { render } from "./StickyModalComponent.vue?vue&type=template&id=06752d40&scoped=true"
import script from "./StickyModalComponent.vue?vue&type=script&lang=js"
export * from "./StickyModalComponent.vue?vue&type=script&lang=js"

import "./StickyModalComponent.vue?vue&type=style&index=0&id=06752d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06752d40"]])

export default __exports__